import { render } from "./AppRregullorja.vue?vue&type=template&id=74d42192"
const script = {}

import "./AppRregullorja.vue?vue&type=style&index=0&id=74d42192&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__